import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher, MatDialogRef } from '@angular/material';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { CrudModel } from '@shared/components/crud/crud.model';
import { LoaderService } from '@shared/components/loader/loader.service';
import { isObject } from 'util';
import { settings } from 'cluster';
import { required } from '@rxweb/reactive-form-validators';

interface FieldType {
  id?: number, 
  value: string, 
  name: string
}

/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-edit-form-identity',
  templateUrl: './edit-form-identity.html',
  styleUrls: ['./edit-form-identity.scss']
})
export class EditFormIdentityComponent implements OnInit {

  @Input() fieldSettings;
  @Input() crmFields;
  @Input() currentForm;
  @Input() creatingField;
  @Input() editorMode;
  @Output() indentityChange = new EventEmitter<any>();
  @Output() indentityFormValid = new EventEmitter<any>();
  @Output() fieldRulesChange = new EventEmitter<any>();
  @Output() fieldRulesChangeOnCreate = new EventEmitter<any>();

  dialogConfirm = {
    titleDialogConfirm: null,
    subTitleDialogConfirm: null,
    disableCloseDialogConfirm: null
  };

  formulario: FormGroup;

  selectedFieldTypeIndex: any = null;

  selectTabelaTotvs = true;
  selectColunaTotvs = true;
  selectTabelaRubeus = true;
  selectColunaRubeus = true;

  hideTotvsFields = true;
  hideRubeusFields = true;

  selectedCrmField;

  fieldTypes = [
    {name: 'Campo de texto', value: 'textfield', id:  9},
    {name: 'Área de texto', value: 'textarea', id:  9},
    {name: 'E-mail', value: 'email', id:  3},
    {name: 'Número', value: 'number', id:  5},
    {name: 'Select', value: 'select',  id:  11},
    {name: 'Senha', value: 'password',  id:  6},
    {name: 'Data', value: 'datetime', id:  2},
    {name: 'Caixa de seleção', value: 'checkbox', id:  1},
    {name: 'Botão de opção', value: 'radio', id:  7}
  ];

  disabledInput = false;

  filteredTableTotvs: Observable<string[]>;
  filteredColumnTotvs: Observable<string[]>;

  filteredTableRubeus: Observable<string[]>;
  filteredColumnRubeus: Observable<any[]>;

  fieldTotvs: any;
  fieldRubeus: any;

  optionSelectTabelaTotvs: string;
  optionSelectTabelaRubeus: string;

  dataComponent: any;

  dadosReadCustomFields: any;

  public matcher = new MyErrorStateMatcher();

  constructor(
    private formBuilder: FormBuilder,
    private crudModel: CrudModel,
    private loaderService: LoaderService
    ) {}

  ngOnInit() {
    if (this.editorMode) {
      this.formEdit(this.fieldSettings);
    } else {
      this.crmFields.forEach((field) => {
        if (this.fieldSettings && field.attr === this.fieldSettings.rubeus_field) {
          this.selectedCrmField = field;
        }
      });

      if (this.creatingField === true) {
        this.formAdd();
      } else {
        this.formUpdate(this.fieldSettings);
      }

      this.formChanges();
      this.filterColumnRubeus();
    }

  }

  get f() { return this.formulario.controls; }

  onSubmit() {
    if (this.dataComponent.data.action === 'add' && this.formulario.valid) {
      this.customFieldsCreate();
    } else if (this.dataComponent.data.action === 'update' && this.formulario.valid) {
      this.customFieldsUpdate();
    }
  }

  private formAdd() {
    this.indentityFormValid.emit(false);
    this.formulario = this.formBuilder.group({
      integracaoTotvs: [false],
      integracaoRubeus: [false],
      tabelaTotvs: [null],
      colunaTotvs: [null],
      nomeAlternativoTotvs: [null],
      tabelaRubeus: [null],
      colunaRubeus: [null],
      ps_table: [false],
      fieldType: [null, [Validators.required]],
      multivalue: [false, [Validators.required]]
    });
    this.f.tabelaRubeus.valueChanges.subscribe( (val) => {
      this.filterColumnRubeus();
    });
  }

  private formUpdate(data) {
    this.formulario = this.formBuilder.group({
      integracaoTotvs: [null],
      integracaoRubeus: [null],
      tabelaTotvs: [data.totvs_table],
      colunaTotvs: [data.totvs_field],
      nomeAlternativoTotvs: [data.totvs_alternative_name],
      tabelaRubeus: [null],
      colunaRubeus: [this.selectedCrmField],
      ps_table: [{value: null, disabled: true}],
      fieldType: [null, [Validators.required]],
      multivalue: [null, [Validators.required]]
    });
    this.setFieldTypeRules(this.selectedCrmField);

    if (data.ps_table === 0) {
      this.f.ps_table.setValue(false);
    } else if (data.ps_table === 1) {
      this.f.ps_table.setValue(true);
    }

    if (data.rubeus_table === 0) {
      this.f.tabelaRubeus.setValue(false);
    } else if (data.rubeus_table === 1) {
      this.f.tabelaRubeus.setValue(true);
    }

    if (data.multivalued === 0) {
      this.f.multivalue.setValue(false);
    } else {
      this.f.multivalue.setValue(true);
    }

    if (this.f.tabelaRubeus.value !== null) {
      this.f.integracaoRubeus.setValue(true);
      this.setValidationInRubeusIntegration(true);
      this.hideRubeusFields = false;
    }

    if (this.f.tabelaTotvs.value !== null) {
      this.f.integracaoTotvs.setValue(true);
      this.setValidationTOTVSIntegration(true);
      this.hideTotvsFields = false;
    }

    if (this.currentForm && this.currentForm.components[0]) {
      this.fieldTypes.forEach(
        (value , index) => {
          if (value.value === this.currentForm.components[0].type) {
            this.selectedFieldTypeIndex = index;
          }
        }
      );
      this.f.fieldType.setValue(this.fieldTypes[this.selectedFieldTypeIndex]);
    } else {
      this.f.fieldType.setValue(this.fieldTypes[0]);
    }

    this.f.tabelaRubeus.valueChanges.subscribe( (val) => {
      this.filterColumnRubeus();
    });
  }

  private formEdit(data) {
    this.formulario = this.formBuilder.group({
      integracaoTotvs: [{value: null, disabled: true}],
      integracaoRubeus: [{value: null, disabled: true}],
      tabelaTotvs: [ {value: data.totvs_table, disabled: true}],
      colunaTotvs: [{value: data.totvs_field, disabled: true}],
      nomeAlternativoTotvs: [{value: data.totvs_alternative_name, disabled: true}],
      tabelaRubeus: [ {value: null, disabled: true}],
      colunaRubeus: [ {value: {name: data.rubeus_field}, disabled: true}],
      ps_table: [ {value: null, disabled: true}],
      fieldType: [{value: null, disabled: true}, [Validators.required]],
      multivalue: [{value: null, disabled: true}, [Validators.required]]
    });

    if (data.rubeus_table === 0) {
      this.f.tabelaRubeus.setValue(false);
    } else if (data.rubeus_table === 1) {
      this.f.tabelaRubeus.setValue(true);
    }

    if (data.ps_table === 0) {
      this.f.ps_table.setValue(false);
    } else if (data.ps_table === 1) {
      this.f.ps_table.setValue(true);
    }

    if (data.multivalued === 0) {
      this.f.multivalue.setValue(false);
    } else {
      this.f.multivalue.setValue(true);
    }
    if (this.currentForm && this.currentForm.components[0]) {
      this.fieldTypes.forEach(
        (value , index) => {
          if (value.value === this.currentForm.components[0].type) {
            this.selectedFieldTypeIndex = index;
          }
        }
      );
      this.f.fieldType.setValue(this.fieldTypes[this.selectedFieldTypeIndex]);
    } else {
      this.f.fieldType.setValue(this.fieldTypes[0]);
    }

    if (this.f.tabelaRubeus.value !== null) {
      this.f.integracaoRubeus.setValue(true);
      this.hideRubeusFields = false;
    }

    if (this.f.tabelaTotvs.value !== null) {
      this.f.integracaoTotvs.setValue(true);
      this.hideTotvsFields = false;
    }

  }

  private setValidationTOTVSIntegration(setValidation:boolean = false) {
    if(setValidation) {
      this.formulario.controls.tabelaTotvs.setValidators(Validators.required);
      this.formulario.controls.colunaTotvs.setValidators(Validators.required);
      this.formulario.controls.nomeAlternativoTotvs.setValidators([
        Validators.maxLength(30),
        (control: FormControl) => (control.value && control.value.includes('.')) ? {'invalidCharacter': true} : null
      ]);
      this.formulario.controls.tabelaTotvs.setValue(this.f.tabelaTotvs.value);
      this.formulario.controls.colunaTotvs.setValue(this.f.colunaTotvs.value);
      this.formulario.controls.nomeAlternativoTotvs.setValue(this.f.nomeAlternativoTotvs.value);
      this.hideTotvsFields = false;
      this.formulario.controls.tabelaTotvs.updateValueAndValidity();
      this.formulario.controls.colunaTotvs.updateValueAndValidity();
      this.formulario.controls.nomeAlternativoTotvs.updateValueAndValidity();
    }else {
      this.formulario.controls.integracaoTotvs.valueChanges.subscribe(val => {
        if (val === true) {
          this.formulario.controls.tabelaTotvs.setValidators(Validators.required);
          this.formulario.controls.colunaTotvs.setValidators(Validators.required);
          this.formulario.controls.nomeAlternativoTotvs.setValidators([
            Validators.maxLength(30),
            (control: FormControl) => (control.value && control.value.includes('.')) ? {'invalidCharacter': true} : null
          ]);
          this.formulario.controls.tabelaTotvs.setValue(null);
          this.formulario.controls.colunaTotvs.setValue(null);
          this.formulario.controls.nomeAlternativoTotvs.setValue(null);
          this.hideTotvsFields = false;
          this.formulario.controls.tabelaTotvs.updateValueAndValidity();
          this.formulario.controls.colunaTotvs.updateValueAndValidity();
          this.formulario.controls.nomeAlternativoTotvs.updateValueAndValidity();
        } else {
          this.formulario.controls.tabelaTotvs.setValidators(null);
          this.formulario.controls.colunaTotvs.setValidators(null);
          this.formulario.controls.nomeAlternativoTotvs.setValidators(null);
          this.formulario.controls.tabelaTotvs.setValue(null);
          this.formulario.controls.colunaTotvs.setValue(null);
          this.formulario.controls.nomeAlternativoTotvs.setValue(null);
          this.hideTotvsFields = true;
          this.formulario.controls.tabelaTotvs.updateValueAndValidity();
          this.formulario.controls.colunaTotvs.updateValueAndValidity();
          this.formulario.controls.nomeAlternativoTotvs.updateValueAndValidity();
        }
      });
     }
  }
  
  private setValidationInRubeusIntegration(setValidation = false) {
    if (setValidation) {
      this.formulario.controls.tabelaRubeus.setValidators(Validators.required);
      this.formulario.controls.colunaRubeus.setValidators(Validators.required);
      this.formulario.controls.tabelaRubeus.setValue(this.f.tabelaRubeus.value);
      this.hideRubeusFields = false;
      this.formulario.controls.colunaRubeus.updateValueAndValidity();
      this.formulario.controls.tabelaRubeus.updateValueAndValidity();
    } else {
      this.formulario.controls.integracaoRubeus.valueChanges.subscribe(val => {
        if (val === true) {
          this.formulario.controls.tabelaRubeus.setValidators(Validators.required);
          this.formulario.controls.colunaRubeus.setValidators(Validators.required);
          this.formulario.controls.tabelaRubeus.setValue(false);
          this.hideRubeusFields = false;
          this.formulario.controls.colunaRubeus.updateValueAndValidity();
          this.formulario.controls.tabelaRubeus.updateValueAndValidity();
        } else {
          this.formulario.controls.tabelaRubeus.setValidators(null);
          this.formulario.controls.colunaRubeus.setValidators(null);
          this.formulario.controls.tabelaRubeus.setValue(null);
          this.formulario.controls.colunaRubeus.setValue(null);
          this.hideRubeusFields = true;
          this.formulario.controls.colunaRubeus.updateValueAndValidity();
          this.formulario.controls.tabelaRubeus.updateValueAndValidity();
        }
      });
    }
  }

  public changesOnMultivalue(fieldType: FieldType): void {  
    if (fieldType?.id == 7 && this.formulario.get('multivalue').value) {
      this.formulario.get('multivalue').patchValue(false);
    } else {
      this.formulario.get('multivalue').enable();
    }
  }

  public formChanges() {
    this.setValidationInRubeusIntegration();
    this.setValidationTOTVSIntegration();

    this.formulario.controls.colunaRubeus.valueChanges.subscribe(val => {
      this.setFieldTypeRules(val);
    });

    this.formulario.controls.fieldType.valueChanges.subscribe(val => {
        this.changesOnMultivalue(val);
    });

    this.formulario.valueChanges.subscribe( val => {
      if (this.formulario.valid) {
        if (isObject(val.fieldType)) {
          this.indentityFormValid.emit(true);
        } else {
          this.indentityFormValid.emit(false);
        }
      } else {
        this.indentityFormValid.emit(false);
      }

      if (this.creatingField) {
        if (this.formulario.valid) {
          if (this.formulario.controls.integracaoRubeus.value) {
            if (isObject(val.colunaRubeus)) {
            const data =  {
                settings: {
                  totvs_table : val.tabelaTotvs,
                  totvs_field: val.colunaTotvs,
                  totvs_alternative_name : val.nomeAlternativoTotvs,
                  rubeus_table: Number(val.tabelaRubeus),
                  rubeus_field: val.colunaRubeus.attr,
                  ps_table: val.ps_table,
                  field_type_id: val.fieldType.id,
                  type: val.fieldType.value,
                  multivalued:  Number(val.multivalue),
                  label: val.fieldType.name
              },
              };
            this.indentityChange.emit(data);
            }
          } else {
            const data =  {
              settings: {
                totvs_table : val.tabelaTotvs,
                totvs_field: val.colunaTotvs,
                totvs_alternative_name : val.nomeAlternativoTotvs,
                rubeus_table: null,
                rubeus_field: null,
                ps_table: val.ps_table,
                field_type_id: val.fieldType.id,
                type: val.fieldType.value,
                multivalued:  Number(val.multivalue),
                label: val.fieldType.name
            },
            };
            this.indentityChange.emit(data);
          }
        }
      } else {
        if (this.formulario.controls.integracaoRubeus.value) {
          if (isObject(val.colunaRubeus)) {
          const data =  {
              settings: {
                totvs_table : val.tabelaTotvs,
                totvs_field: val.colunaTotvs,
                totvs_alternative_name : val.nomeAlternativoTotvs,
                rubeus_table: Number(val.tabelaRubeus),
                rubeus_field: val.colunaRubeus.attr,
                ps_table: val.ps_table,
                field_type_id: val.fieldType.id,
                type: val.fieldType.value,
                multivalued:  Number(val.multivalue),
                label: val.fieldType.name
            },
            };
          this.indentityChange.emit(data);
          }
        } else {
          const data =  {
            settings: {
              totvs_table : val.tabelaTotvs,
              totvs_field: val.colunaTotvs,
              totvs_alternative_name : val.nomeAlternativoTotvs,
              rubeus_table: null,
              rubeus_field: null,
              ps_table: val.ps_table,
              field_type_id: val.fieldType.id,
              type: val.fieldType.value,
              multivalued:  Number(val.multivalue),
              label: val.fieldType.name
          },
          };
          this.indentityChange.emit(data);
        }
      }
    });
  }

  private customFieldsCreate() {
    this.loaderService.setChangesLoaderState(true);
    this.formulario.patchValue({
      // obrigatorio: this.switchValueSlideToggle(this.formulario.value.obrigatorio)
    });
  }

  private customFieldsUpdate() {
    this.loaderService.setChangesLoaderState(true);
  }

  setFieldTypeRules(val) {
    if (isObject(val)) {
      const type = val.type;
      const rules = val.rule.split(',');

      let max = 0;
      let pattern = 'none';
      let predefined = false;
      let typeSex = false;
      let typeLogical = false;

      rules.forEach(rule => {
        if (rule.startsWith('max:')) {
          max = Number(rule.split(':')[1]);
        }
        if (rule === 'email') {
          pattern = 'email';
        }
        if (rule === 'cpf') {
          pattern = 'cpf';
        }
        if (rule === 'cep') {
          pattern = 'cep';
        }
      });

      if (val.tipoSexo) {
        typeSex = true;
      }

      if (type === 'date') {
        pattern = 'date';
      }

      if (type === 'datetime') {
        pattern = 'datetime';
      }

      if (val.tipoLogico) {
        typeLogical = true;
      }

      if (val.temOpcoesPredefinidas == 1) {
        predefined = true;
      }

      if (this.currentForm && this.currentForm.components[0]) {
        this.fieldTypes.forEach(
          (value , index) => {
            if (value.value === this.currentForm.components[0].type) {
              this.selectedFieldTypeIndex = index;
            }
          }
        );
        if (this.selectedFieldTypeIndex !== null) {
          this.f.fieldType.setValue(this.fieldTypes[this.selectedFieldTypeIndex]);
        }
      }
      if (this.currentForm.components[0].key) {
        const ruleData = {
          max,
          pattern,
          predefined,
          typeLogical,
          typeSex,
          fieldType : val.attr
        };
        this.fieldRulesChange.emit(ruleData);
      } else {
        const ruleData = {
          max,
          pattern,
          predefined,
          typeLogical,
          typeSex,
          fieldType : val.attr
        };
        this.fieldRulesChangeOnCreate.emit(ruleData);
      }
    }
  }

  onColumnRubeusChanged(e) {
    this.f.colunaRubeus.setValue('');
    this.filterColumnRubeus();
  }

  private filterColumnRubeus() {
    this.fieldRubeus = this.crmFields;
    let options = [];
    if (!this.f.tabelaRubeus.value) {
      options = this.fieldRubeus.filter( x => {
        return x.attr.split(['.'])[0] === 'pessoa' || x.attr.split(['.'])[0] === 'contato' ;
      } );
    } else {
      options = this.fieldRubeus.filter( x => {
        return x.attr.split(['.'])[0] !== 'pessoa' && x.attr.split(['.'])[0] !== 'contato';
      } );
    }
    this.filteredColumnRubeus = this.formulario.controls.colunaRubeus.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value, options))
    );
  }

  public getOptionText(opt) {
    if (opt && opt.name) {
      return opt.name;
    }
  }

  private _filter(value, opt): string[] {
    let filterValue = '';
    if (isObject(value)) {
    } else {
      if ( value !== null ) {
        filterValue = value.toLowerCase();
      }
    }
    return opt.filter(option => option.name.toLowerCase().includes(filterValue));
  }

  checkStatus(event, valSelected) {
    if (this.f.tabelaRubeus.value === valSelected) {
      this.f.tabelaRubeus.setValue(null);
      event.preventDefault();
    }
  }

}
